import { createSelector } from 'reselect';

export const getRouting = state => state.router;

const getLocation = state => getRouting(state).location;

const RoutingSelectors = {
    makeRouting: createSelector([getRouting], router => router),
    makeLocation: createSelector([getLocation], location => location),
    makeSearch: createSelector([getLocation], location => location.search),
    makePathname: createSelector([getLocation], location => location.pathname),
    makeListingId: createSelector([getLocation], location => location.pathname.split('/')[3]),
};

export default RoutingSelectors;
